export default "__VITE_ASSET__a2a524c4__"